module.exports = __webpack_public_path__ + "static/img/logo-strukton-systems.e695197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-strukton-systems.jpg
// module id = 1GWU
// module chunks = 1